import React, { forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface SwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange" | "type"> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  label?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { checked, onCheckedChange, label, className, disabled, ...rest },
  ref,
) {
  return (
    <label
      className={cn(
        "inline-flex cursor-pointer items-center gap-2",
        disabled && "cursor-not-allowed opacity-40",
        className,
      )}
    >
      <span className="relative inline-flex h-[18px] w-[30px] shrink-0 items-center">
        <input
          ref={ref}
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          disabled={disabled}
          {...rest}
        />
        <span
          className={cn(
            "absolute inset-0 rounded-full border border-border bg-muted transition-colors",
            "peer-checked:border-primary peer-checked:bg-primary",
          )}
        />
        <span
          className={cn(
            "absolute left-[3px] h-3 w-3 rounded-full bg-foreground shadow-sm transition-transform",
            "peer-checked:translate-x-3",
          )}
        />
      </span>
      {label && <span className="text-[13px]">{label}</span>}
    </label>
  );
});
